import { StringUnionKeyAsValue } from '~commonInfra/utils/TypescriptHelpers';

export type CatalogContentType = 'database' | 'table' | 'databaseWithCrass' | 'tableWithCrass';

export const CatalogContentTypes: StringUnionKeyAsValue<CatalogContentType> = {
  databaseWithCrass: 'databaseWithCrass',
  tableWithCrass: 'tableWithCrass',
  database: 'database',
  table: 'table',
};
